import { createFileRoute } from "@tanstack/react-router";
import { TrashPage } from "@/components/trash/TrashPage";

/** /p/KEY/trash: deleted items of one product, with restore. */
export const Route = createFileRoute("/_app/p/$productKey/trash")({ component: Trash });

function Trash() {
  const { productKey } = Route.useParams();
  return <TrashPage productKey={productKey} />;
}
